import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Agent, { AgentReports } from './../models/Agent';
import { get } from 'lodash';
import moment from 'moment';

export function getAgent(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.AGENT_LIST,
        params: params,
        parser: agentsDataParser,
    }).get();
}

export function getAllAgent(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.AGENT_ALL_LIST,
        parser: agentsDataParser,
    }).get();
}

export function getAgentListReports(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.AGENT_LIST_REPORTS,
        params: params,
        parser: data => agentListReportsParser(data, params),
    }).get();
}

export function getAgentDetail(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.AGENT_DETAIL,
        endpointParams: { id },
        parser: (data) => new Agent(data.data),
    }).get();
}

export function createAgentDetail(agent) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.AGENT_ACTION,
        parser: (data) => new Agent(data.agent),
    }).post(agent.export());
}

export function updateAgentDetail(agent) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.AGENT_ACTION,
        parser: (data) => new Agent(data.agent),
    }).put(agent.export());
}

export function deleteAgentDetail(agent) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.AGENT_DETAIL,
        endpointParams: { id: agent.id }
    }).delete();
}

function agentListReportsParser(data = {}, params = {}) {
    return {
        ...data.data,
        startDate: params.startDate && moment.utc(params.startDate),
        endDate: params.endDate && moment.utc(params.endDate),
        result: (data.data.result || []).map(item => new AgentReports(item))
    }
}

const agentsDataParser = (data) => ({
    result: (data.data.result || data.data).map(item => new Agent(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})